var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4859_58487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 2C22.5304 2 23.0391 2.21071 23.4142 2.58579C23.7893 2.96086 24 3.46957 24 4V28C24 28.5304 23.7893 29.0391 23.4142 29.4142C23.0391 29.7893 22.5304 30 22 30H10C9.46957 30 8.96086 29.7893 8.58579 29.4142C8.21071 29.0391 8 28.5304 8 28V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H22ZM10 0C8.93913 0 7.92172 0.421427 7.17157 1.17157C6.42143 1.92172 6 2.93913 6 4V28C6 29.0609 6.42143 30.0783 7.17157 30.8284C7.92172 31.5786 8.93913 32 10 32H22C23.0609 32 24.0783 31.5786 24.8284 30.8284C25.5786 30.0783 26 29.0609 26 28V4C26 2.93913 25.5786 1.92172 24.8284 1.17157C24.0783 0.421427 23.0609 0 22 0L10 0Z",
    fill: "#0FA958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 28C16.5304 28 17.0391 27.7893 17.4142 27.4142C17.7893 27.0391 18 26.5304 18 26C18 25.4696 17.7893 24.9609 17.4142 24.5858C17.0391 24.2107 16.5304 24 16 24C15.4696 24 14.9609 24.2107 14.5858 24.5858C14.2107 24.9609 14 25.4696 14 26C14 26.5304 14.2107 27.0391 14.5858 27.4142C14.9609 27.7893 15.4696 28 16 28Z",
    fill: "#0FA958"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4859_58487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.96d774590c479878aab9d58068fa1f37.svg";
export { ForwardRef as ReactComponent };